module.exports = __webpack_public_path__ + "static/media/pool-bar.98e04d37.jpg";